import React, {useState} from 'react';
import {mdiSortAscending, mdiSortDescending} from "@mdi/js";
import Icon from "@mdi/react";
import {Dropdown} from "react-bootstrap";
import {useLaravelReactI18n} from "laravel-react-i18n";

export default function HeaderItem(props) {
    const { t,getLocales } = useLaravelReactI18n();
    const [editMode,setEditMode] = useState(false);
    const toggleEditMode = () => setEditMode(!editMode);

    const handleClick = () => {
        if (!props.disabled){
            if (props.colDefinition.enum) {
                if (!editMode)
                {
                    toggleEditMode();
                }
            }
            else if (props.direction==='DESC'){
                props.onSort(props.id,'ASC');
            } else {
                props.onSort(props.id,'DESC');
            }
        }
    }

    const onEnumSelect = (key) => {
        props.onEnumSelect(props.id,key);
        toggleEditMode();
    }

    const renderEditMode = () => {
        return (

          <Dropdown onSelect={onEnumSelect}>
            <Dropdown.Toggle size="sm" variant="outline-secondary" id="dropdown-basic">
                {props.colDefinition && props.enumSelected ? props.colDefinition.enum[props.enumSelected] : t('Select Value')}
            </Dropdown.Toggle>
            <Dropdown.Menu className={"scrollable-dropdown"}>
              <Dropdown.Item eventKey={-1}>{t('all')}</Dropdown.Item>
              {Object.entries(props.colDefinition.enum).map(([key,item], index) => {
                return (
                  <Dropdown.Item eventKey={key} key={index}>
                    {item}
                  </Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        )
    }

    if (props.colDefinition.enum){
        return (
            <th style={{cursor: props.disabled ? 'default': 'pointer'}} className={props.className} onClick={handleClick}>{editMode ? renderEditMode() : <> {props.children} {props.enumSelected ? '('+props.colDefinition.enum[props.enumSelected]+')'  : ''}</>}</th>
        );
    }

    return (
        <th style={{cursor: props.disabled ? 'default': 'pointer'}} className={props.className} onClick={handleClick}>{props.children} {(props.sortable && props.direction!=null) && (<Icon path={props.direction === 'ASC'?mdiSortAscending:mdiSortDescending} size={1} />)}</th>
    );
}
